export const MARC_TYPES = {
  BIB: 'bibliographic',
  HOLDINGS: 'holdings',
  AUTHORITY: 'authority',
};
